<template>
  <div>
    <Header v-if="this.userInfo.user.permission == 'super_admin'" />

    <HodHeader v-if="this.userInfo.user.permission == 'hod'" />
    <CoordinateHeader v-if="this.userInfo.user.permission == 'co-ordinator'" />
    <InstructorHeader v-if="this.userInfo.user.permission == 'instructor'" />

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <confirmPopup
      v-if="popupwindow == true"
      :title="titlepass"
      :deleteLoading="deleteLoading"
      @cancelClick="popupwindow = false"
      @confirmClick="deletecourse(idpass)"
    />
    <DuplicatePopup
      v-if="duplicatewindow == true"
      :id="idpass"
      @cancelClick="handleDuplicateClose"
    />

    <div class="pt-5 pb-10 max-h-screen overflow-y-auto">
      <div class="container mx-auto max-w-[1200px] flex flex-col gap-5 px-6">
        <div
          class="flex flex-col md:flex-col justify-between lg:flex-row items-start gap-2"
        >
          <h1 class="text-2xl font-bold text-primary text-start md:text-left">
            My Courses
          </h1>

          <div
            class="flex flex-col gap-4 md:flex-row md:items-center md:justify-between flex-wrap"
          >
            <!-- Filter Dropdown -->
            <div>
              <select
                name="model_select"
                id="model_select"
                v-model="selected_filter"
                @change="getCourses(1)"
                class="px-4 py-2 w-full md:w-[160px] rounded-xl text-sm text-white bg-blues font-semibold outline-none transition-colors duration-200 hover:bg-blue-600"
              >
                <option value="" disabled selected>Select sorting</option>
                <option value="title">A to Z</option>
                <option value="-title">Z to A</option>
                <option value="-created_at">New to Old</option>
                <option value="created_at">Old to New</option>
              </select>
            </div>

            <!-- Action Buttons -->
            <div class="flex flex-wrap gap-2">
              <router-link
                v-if="this.userInfo.user.permission != 'instructor'"
                :to="{ name: 'AdminNewCourses' }"
                class="bg-blues text-white px-4 py-2 rounded-xl text-sm font-semibold outline-none transition-colors duration-200 hover:bg-blue-600"
              >
                Add New Course
              </router-link>

              <!-- <router-link
                :to="{ name: 'AdminStudentAssign' }"
                class="bg-blues text-white px-4 py-2 rounded-xl text-sm font-semibold shadow-md transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
              >
                Assign Student
              </router-link> -->

              <!-- <router-link
                :to="{ name: 'AICourseCreate' }"
                class="border border-blues text-blues px-4 py-2 rounded-xl text-sm font-semibold shadow-md transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues"
              >
                AI Course Create
              </router-link> -->
            </div>

            <!-- Search Form -->
            <form
              @submit.prevent="getCourses(1)"
              class="w-full md:w-auto flex gap-2 items-center"
            >
              <div
                class="flex w-full md:w-[300px] rounded-xl overflow-hidden"
                style="box-shadow: 0px 2px 20px 0px #105c8e26"
              >
                <input
                  type="text"
                  name="search"
                  id="search"
                  v-model="search_list"
                  @input="getCourses(1)"
                  placeholder="Search The Course"
                  class="flex-1 px-4 py-2 outline-none text-sm text-gray-700"
                />
                <button
                  type="submit"
                  :disabled="disable_submit == true"
                  :class="
                    this.disable_submit == true
                      ? 'bg-gray-200 text-black cursor-not-allowed'
                      : 'bg-blues hover:bg-[#18469d] cursor-pointer'
                  "
                  class="px-4 flex items-center justify-center"
                >
                  <img
                    src="@/assets/search.webp"
                    alt="Search"
                    class="w-5 h-5"
                  />
                </button>
              </div>
              <img
                v-if="disable_submit"
                src="@/assets/loading.gif"
                alt="loading"
                class="w-6 h-6 object-contain"
              />
            </form>
          </div>
        </div>

        <h1 class="text-lg font-bold text-primary text-start md:text-left">
          Total: {{ course_count || 0 }}
        </h1>

        <div class="flex items-center gap-2 mb-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-4 h-4 text-blue-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2l-7 7v5l-4 2v-7L3 6V4z"
            />
          </svg>

          <p class="text-sm font-bold text-slate-800">Field Filters:</p>
        </div>
        <div>
          <div class="grid grid-cols-1 md:grid-cols-6 gap-5">
            <!-- Batch -->
            <select
              id="batch_id"
              v-model="selectedBatchId"
              @change="onBatchChange"
              class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold capitalize leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:bg-gray-100"
            >
              <option value="" disabled>Select Batch</option>
              <option
                v-for="batch_year in batch_years"
                :key="batch_year.id"
                :value="batch_year.id"
              >
                {{ batch_year.year }}
              </option>
            </select>

            <!-- Program -->
            <select
              id="program_id"
              v-model="selectedProgramId"
              @change="onProgramChange"
              class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold capitalize leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:bg-gray-100"
            >
              <option value="" disabled>Select Program</option>
              <option
                v-for="program in programs"
                :key="program.id"
                :value="program.id"
              >
                {{ program.name }}
              </option>
            </select>

            <!-- Semester -->
            <select
              id="semester_id"
              v-model="selectedSemesterId"
              @change="onSemesterChange"
              class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold capitalize leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:bg-gray-100"
            >
              <option value="" disabled>Select Semester</option>
              <option
                v-for="semester in semetser_list"
                :key="semester.id"
                :value="semester.id"
              >
                {{ semester.semester }}
              </option>
            </select>

            <!-- Course Type -->
            <select
              id="coursetype_id"
              v-model="selectedCourseType"
              @change="onCourseTypeChange"
              class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold capitalize leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:bg-gray-100"
            >
              <option value="" disabled>Select Course type</option>
              <option
                v-for="course_type in course_types"
                :key="course_type.title"
                :value="course_type.title"
              >
                {{ course_type.title }}
              </option>
            </select>

            <!-- Instructor Email -->
            <select
              id="instructor_id"
              v-model="selectedInstructorEmail"
              @change="getCourses(1)"
              class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold capitalize leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:bg-gray-100"
            >
              <option value="" disabled>Select instructor email</option>
              <option
                v-for="instructor in instructor_list"
                :key="instructor.email"
                :value="instructor.email"
              >
                {{ instructor.email }}
              </option>
            </select>

            <!-- Instructor Name -->
            <select
              id="instructor_name"
              v-model="selectedInstructorName"
              @change="getCourses(1)"
              class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold capitalize leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:bg-gray-100"
            >
              <option value="" disabled>Select instructor name</option>
              <option
                v-for="instructor in instructor_list"
                :key="instructor.display_name"
                :value="instructor.display_name"
              >
                {{ instructor.display_name }}
              </option>
            </select>

            <!-- Status -->
            <select
              id="selected_publish"
              v-model="selectedPublishStatus"
              @change="getCourses(1)"
              class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold capitalize leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 hover:bg-gray-100"
            >
              <option value="" disabled>Select Status</option>
              <option :value="true">Published</option>
              <option :value="false">Unpublished</option>
            </select>

            <button
              type="button"
              @click="clearFilters"
              class="text-blue-600 underline flex items-center text-xs font-semibold gap-1 hover:text-blues"
            >
              <img
                src="@/assets/attendance/cancel.webp"
                alt="Clear"
                class="w-3 h-3 object-contain"
              />
              Clear All
            </button>
          </div>
        </div>

        <div
          v-if="loading"
          class="flex items-center justify-center h-[calc(100vh-350px)]"
        >
          <img src="@/assets/newd/loading.gif" alt="Loading" />
        </div>
        <div v-else>
          <div v-if="courselist.length > 0">
            <div
              class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-10"
            >
              <div
                class="rounded-3xl shadow-md"
                v-for="course in courselist"
                :key="course"
              >
                <div
                  class="flex flex-col h-full justify-between text-start sm:text-left px-4 sm:px-6 py-6"
                >
                  <router-link
                    :to="{
                      name: 'InstructorStudents',
                      params: {
                        course_id: course.id,
                        department_id: course.department.id,
                      },
                    }"
                    class="flex flex-col gap-1 min-h-[300px] group"
                  >
                    <div class="relative overflow-hidden rounded-lg basis-[200px] shrink-0">
                      <img
                        v-if="course.thumbnail"
                        class="object-cover object-center h-[200px] w-full rounded-lg transition-transform duration-300 hover:scale-110"
                        :src="course.thumbnail"
                        alt="Course Thumbnail"
                      />
                      <img
                        v-else
                        class="object-cover object-center h-[200px] w-full rounded-lg transition-transform duration-300 hover:scale-110"
                        src="@/assets/coding.svg"
                        alt="Default Thumbnail"
                      />
                      
                      <!-- Status Badge inside image corner -->
                      <span
                        class="absolute top-2 right-2 text-[10px] font-bold px-2 py-1 rounded-md shadow uppercase tracking-wide z-10"
                        :class="[
                          course?.is_published === true ? 'bg-green-500 text-white' : 
                          course?.is_published === false ? 'bg-red-500 text-white' : 'bg-gray-500 text-white'
                        ]"
                      >
                        {{
                          course?.is_published === true
                            ? "Published"
                            : course?.is_published === false
                            ? "Unpublished"
                            : "NA"
                        }}
                      </span>
                    </div>

                    <!-- <div class="flex flex-col justify-between">  -->

                    <h1 class="font-bold text-lg text-primary py-2">
                      {{ course.title.slice(0, 50) }}
                      <p
                        v-if="course.title.length > 50"
                        class="text-primary text-sm mt-1 font-semibold"
                      >
                        ...More
                      </p>
                    </h1>

                    <div class="flex flex-col gap-1">
                      <p class="text-sm">
                        <span class="font-semibold">Batch:</span>
                        {{ course?.batch?.year || "NAN" }}
                      </p>

                      <p class="text-sm">
                        <span class="font-semibold">Program:</span>
                        {{ course?.program?.name || "NAN" }}
                      </p>
                      <p class="text-sm">
                        <span class="font-semibold">Course Code:</span>
                        {{ course?.course_code || "NAN" }}
                      </p>
                      <!-- <p class="text-sm">
                        <span class="font-semibold">Department: </span
                        >{{ course?.department?.name || "NAN" }}
                      </p> -->
                      <p class="text-sm">
                        <span class="font-semibold">Semester: </span
                        >{{ course?.semester?.semester || "NAN" }}
                      </p>
                      <!-- <p class="text-sm break-words">
                        <span class="font-semibold whitespace-nowrap"
                          >Instructor Email:</span
                        >
                        <span v-if="course.instructor.length > 0">
                          {{ course?.instructor[0].user.email }}
                        </span>
                        <span v-else>NAN</span>
                      </p> -->
                      <p class="text-sm">
                        <span class="font-semibold">Section:</span>
                        {{ course?.class_section || "NAN" }}
                      </p>
                      <p class="text-sm">
                        <span class="font-semibold">Course Type:</span>
                        {{ course?.course_type?.title || "NAN" }}
                      </p>
                      <p class="text-sm">
                        <span class="font-semibold">Instructor Name:</span>
                        <span v-if="course.instructor.length > 0">
                          {{ course.instructor[0].user.display_name }}
                        </span>
                        <span v-else>NAN</span>
                      </p>

                      <p class="text-sm">
                        <span class="font-semibold">Student Count:</span>
                        {{ course?.student_count || 0 }}
                      </p>
                    </div>
                  </router-link>

                  <div
                    class="mb-5 mt-2 flex items-center gap-2 hidden"
                    v-if="
                      this.userInfo.user.permission == 'super_admin' ||
                      this.userInfo.user.permission == 'hod' ||
                      this.userInfo.user.permission == 'co-ordinator'
                    "
                  >
                    <button
                      @click="
                        changeInstructorPopup = course.id;
                        findinstructor(course.id);
                      "
                      class="text-xs cursor-pointer bg-blues text-white px-3 py-1 font-bold rounded-2xl transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
                    >
                      Change Instructor
                    </button>

                    <!--  -->
                    <router-link
                      :to="{
                        name: 'InstructorStudents',
                        params: {
                          course_id: course.id,
                          department_id: course.department.id,
                        },
                      }"
                      class="text-xs cursor-pointer bg-blues text-white px-3 py-1 font-bold rounded-2xl transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
                    >
                      Dashboard
                    </router-link>
                  </div>

                  <div class="flex items-center gap-3 sm:gap-4 xl:gap-6 mt-5 w-full">
                    <!-- <div @click="editCoursePopup = true; currentId = course.id">
                    <img src="@/assets/newd/icon2.svg" alt="Edit Course" />
                  </div> -->

                    <!-- <div
                    @click="
                      addLessonUnitPopup = true;
                      currentId = course.id;
                    "
                  >
                    <img src="@/assets/newd/icon1.svg" alt="Add Course" class=" cursor-pointer" />
                  </div> -->

                    <!-- AddLessonUnit -->

                    <router-link
                      :to="{
                        name: 'AddLessonUnit',
                        params: { course_id: course.id },
                        query: { title: course.title }
                      }"
                      class="flex flex-col gap-1"
                    >
                      <div class="relative group">
                        <svg class="w-[25px] h-[25px] text-[#0085DB] group-hover:text-[#006CB3] transition-colors cursor-pointer" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7.59424 15.1123C7.59424 14.8135 7.71293 14.527 7.9242 14.3157C8.13548 14.1044 8.42203 13.9857 8.72082 13.9857H13.9677V8.73888C13.9677 8.4401 14.0864 8.15355 14.2976 7.94227C14.5089 7.731 14.7955 7.6123 15.0942 7.6123C15.393 7.6123 15.6796 7.731 15.8908 7.94227C16.1021 8.15355 16.2208 8.4401 16.2208 8.73888V13.9857H21.4677C21.7664 13.9857 22.053 14.1044 22.2643 14.3157C22.4755 14.527 22.5942 14.8135 22.5942 15.1123C22.5942 15.4111 22.4755 15.6976 22.2643 15.9089C22.053 16.1202 21.7664 16.2389 21.4677 16.2389H16.2208V21.4857C16.2208 21.7845 16.1021 22.0711 15.8908 22.2823C15.6796 22.4936 15.393 22.6123 15.0942 22.6123C14.7955 22.6123 14.5089 22.4936 14.2976 22.2823C14.0864 22.0711 13.9677 21.7845 13.9677 21.4857V16.2389H8.72082C8.42203 16.2389 8.13548 16.1202 7.9242 15.9089C7.71293 15.6976 7.59424 15.4111 7.59424 15.1123Z" fill="currentColor"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M8.58322 3.38101C13.1656 2.873 17.7901 2.873 22.3725 3.38101C25.0623 3.68136 27.2339 5.79995 27.549 8.50451C28.0937 13.1525 28.0937 17.8475 27.549 22.4955C27.2325 25.2001 25.0609 27.3172 22.3725 27.619C17.7901 28.127 13.1656 28.127 8.58322 27.619C5.89339 27.3172 3.72179 25.2001 3.40672 22.4955C2.86443 17.8476 2.86443 13.1524 3.40672 8.50451C3.72179 5.79995 5.89486 3.68136 8.58322 3.38101ZM22.1281 5.5747C17.7081 5.08476 13.2476 5.08476 8.82762 5.5747C8.0094 5.66547 7.24567 6.02944 6.65982 6.60781C6.07397 7.18618 5.70021 7.94517 5.59893 8.76216C5.07529 13.2393 5.07529 17.7622 5.59893 22.2393C5.70052 23.056 6.07441 23.8147 6.66023 24.3928C7.24606 24.9708 8.00962 25.3346 8.82762 25.4253C13.2106 25.9141 17.7452 25.9141 22.1281 25.4253C22.9458 25.3343 23.7091 24.9704 24.2946 24.3923C24.8801 23.8143 25.2538 23.0558 25.3553 22.2393C25.879 17.7622 25.879 13.2393 25.3553 8.76216C25.2535 7.94592 24.8797 7.18778 24.2942 6.61003C23.7087 6.03227 22.9456 5.66859 22.1281 5.57764" fill="currentColor"/>
                        </svg>
                        <span
                          class="absolute top-8 z-40 left-1/2 transform -translate-x-1/2 bg-gray-700 text-white text-xs px-2 whitespace-nowrap py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity"
                        >
                          Add
                        </span>
                      </div>
                    </router-link>

                    <router-link
                      v-if="
                        this.userInfo.user.permission == 'super_admin' ||
                        this.userInfo.user.permission == 'hod' ||
                        this.userInfo.user.permission == 'co-ordinator'
                      "
                      :to="{
                        name: 'InstructorCourseEdit',
                        params: { course_id: course.id },
                      }"
                      class="flex flex-col gap-1"
                    >
                      <div class="relative group">
                        <svg class="w-[25px] h-[25px] text-[#047857] group-hover:text-[#03543D] transition-colors cursor-pointer" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M23.8623 18.0513V23.6013C23.8619 24.3866 23.5499 25.1396 22.9946 25.6948C22.4393 26.2501 21.6863 26.5622 20.901 26.5625H6.39978C6.00947 26.5624 5.62304 26.4851 5.2627 26.3351C4.90235 26.1852 4.57519 25.9655 4.30002 25.6887C4.02484 25.4119 3.80708 25.0834 3.65924 24.7222C3.51139 24.361 3.43639 23.9741 3.43853 23.5838V9.09878C3.43621 8.70909 3.51125 8.32282 3.65931 7.96234C3.80736 7.60186 4.02549 7.27436 4.30105 6.9988C4.5766 6.72324 4.90411 6.50512 5.26459 6.35706C5.62506 6.209 6.01134 6.13396 6.40103 6.13628H11.9498" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M23.8622 11.2436L18.756 6.13615M8.54346 19.7536V17.0474C8.54596 16.6011 8.72346 16.1724 9.03721 15.8561L20.9522 3.94115C21.1103 3.78128 21.2985 3.65436 21.506 3.56774C21.7135 3.48112 21.9361 3.43652 22.161 3.43652C22.3858 3.43652 22.6084 3.48112 22.8159 3.56774C23.0234 3.65436 23.2116 3.78128 23.3697 3.94115L26.0585 6.6299C26.2183 6.788 26.3452 6.97624 26.4319 7.18372C26.5185 7.3912 26.5631 7.61381 26.5631 7.83865C26.5631 8.06349 26.5185 8.28609 26.4319 8.49358C26.3452 8.70106 26.2183 8.8893 26.0585 9.0474L14.1435 20.9624C13.8266 21.277 13.3987 21.4544 12.9522 21.4561H10.246C10.0223 21.4565 9.80076 21.4127 9.59405 21.3272C9.38735 21.2418 9.19953 21.1164 9.04138 20.9582C8.88322 20.8001 8.75783 20.6123 8.67238 20.4056C8.58694 20.1988 8.54313 19.9773 8.54346 19.7536Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span
                          class="absolute top-8 z-40 left-1/2 transform -translate-x-1/2 bg-gray-700 text-white text-xs px-2 whitespace-nowrap py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity"
                        >
                          Edit
                        </span>
                      </div>
                    </router-link>

                    <div
                      @click="
                        titlepass = course.title;
                        popupwindow = true;
                        idpass = course.id;
                      "
                      class="cursor-pointer"
                      v-if="
                        this.userInfo.user.permission == 'super_admin' ||
                        this.userInfo.user.permission == 'hod' ||
                        this.userInfo.user.permission == 'co-ordinator'
                      "
                    >
                      <div class="relative group">
                        <svg class="w-[25px] h-[25px] text-[#F36540] group-hover:text-[#D34E2B] transition-colors cursor-pointer" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M4.275 8V8.1H4.375H6.86953L7.88518 25.1547L7.985 25.1488L7.88518 25.1547C7.92461 25.8162 8.21514 26.4377 8.69741 26.8922C9.17968 27.3467 9.8173 27.5998 10.48 27.6H19.52C20.1827 27.5998 20.8203 27.3467 21.3026 26.8922C21.7849 26.4377 22.0754 25.8162 22.1148 25.1547L23.1305 8.1H25.625H25.725V8V7.125C25.725 6.93272 25.6486 6.74831 25.5127 6.61235C25.3767 6.47638 25.1923 6.4 25 6.4H5C4.80772 6.4 4.62331 6.47638 4.48735 6.61235C4.35138 6.74831 4.275 6.93272 4.275 7.125V8ZM18.125 5.35H18.225V5.25V4.375C18.225 4.18272 18.1486 3.99831 18.0127 3.86235C17.8767 3.72638 17.6923 3.65 17.5 3.65H12.5C12.3077 3.65 12.1233 3.72638 11.9873 3.86235C11.8514 3.99831 11.775 4.18272 11.775 4.375V5.25V5.35H11.875H18.125ZM11.875 11.15H11.7693L11.7752 11.2555L12.4002 22.5055L12.4054 22.6H12.5H14H14.1057L14.0998 22.4945L13.4748 11.2445L13.4696 11.15H13.375H11.875ZM16.625 11.15H16.5304L16.5252 11.2445L15.9002 22.4945L15.8943 22.6H16H17.5H17.5946L17.5998 22.5055L18.2248 11.2555L18.2307 11.15H18.125H16.625ZM9.58232 25.054L8.57363 8.1H21.4264L20.4177 25.054L20.4177 25.0541L9.58232 25.054Z" fill="currentColor" stroke="currentColor" stroke-width="0.2"/>
                        </svg>
                        <span
                          class="absolute top-8 z-40 left-1/2 transform -translate-x-1/2 bg-gray-700 text-white text-xs px-2 whitespace-nowrap py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity"
                        >
                          Delete
                        </span>
                      </div>
                    </div>
                    <!-- <div
                      @click="DuplicateCourse(course.id)"
                      class="cursor-pointer"
                      v-if="
                        this.userInfo.user.permission == 'super_admin' ||
                        this.userInfo.user.permission == 'hod' ||
                        this.userInfo.user.permission == 'co-ordinator'
                      "
                    >
                      <div class="relative group">
                        <img
                          src="@/assets/newd/duplicate.svg"
                          alt="Duplicate Course"
                        />
                        <span
                          class="absolute top-8 z-40 left-1/2 transform -translate-x-1/2 bg-gray-700 text-white text-xs px-2 whitespace-nowrap py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity"
                        >
                          Duplicate
                        </span>
                      </div>
                    </div> -->
                    <div
                      @click="
                        duplicatewindow = true;
                        idpass = course.id;
                      "
                      class="cursor-pointer"
                      v-if="
                        this.userInfo.user.permission == 'super_admin' ||
                        this.userInfo.user.permission == 'hod' ||
                        this.userInfo.user.permission == 'co-ordinator'
                      "
                    >
                      <div class="relative group">
                        <svg class="w-[25px] h-[25px] text-[#554BD4] group-hover:text-[#4139A8] transition-colors cursor-pointer" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_2401_679)">
                          <path d="M12.9998 11.5225H1.18164M24.0794 18.9089C24.2753 18.9089 24.4631 18.8311 24.6017 18.6926C24.7402 18.5541 24.818 18.3662 24.818 18.1703V7.09073C24.818 6.69893 24.6624 6.32318 24.3853 6.04614C24.1083 5.7691 23.7325 5.61346 23.3407 5.61346H17.801C17.5592 5.61358 17.3212 5.55438 17.1076 5.44105C16.8941 5.32773 16.7117 5.16373 16.5763 4.96346L14.4549 1.83164C14.3197 1.63157 14.1375 1.46771 13.9243 1.35439C13.711 1.24107 13.4732 1.18176 13.2318 1.18164H7.09073C6.69893 1.18164 6.32318 1.33728 6.04614 1.61432C5.7691 1.89137 5.61346 2.26712 5.61346 2.65891M1.18164 8.568V23.3407C1.18164 23.7325 1.33728 24.1083 1.61432 24.3853C1.89137 24.6624 2.26712 24.818 2.65891 24.818H18.9089C19.3007 24.818 19.6765 24.6624 19.9535 24.3853C20.2305 24.1083 20.3862 23.7325 20.3862 23.3407V12.9998C20.3862 12.608 20.2305 12.2323 19.9535 11.9552C19.6765 11.6782 19.3007 11.5225 18.9089 11.5225H13.3691C13.1274 11.5227 12.8893 11.4635 12.6758 11.3501C12.4623 11.2368 12.2799 11.0728 12.1445 10.8726L10.0231 7.74073C9.88789 7.54067 9.70568 7.3768 9.49243 7.26348C9.27919 7.15017 9.04142 7.09085 8.79994 7.09073H2.65891C2.26712 7.09073 1.89137 7.24637 1.61432 7.52342C1.33728 7.80046 1.18164 8.17621 1.18164 8.568Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          </g>
                          <defs>
                          <clipPath id="clip0_2401_679">
                          <rect width="26" height="26" fill="white"/>
                          </clipPath>
                          </defs>
                        </svg>
                        <span
                          class="absolute top-8 z-40 left-1/2 transform -translate-x-1/2 bg-gray-700 text-white text-xs px-2 whitespace-nowrap py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity"
                        >
                          Duplicate
                        </span>
                      </div>
                    </div>

                    <router-link
                      :to="{
                        name: 'AdminCoursePreview',
                        params: { course_id: course.id },
                      }"
                      class="cursor-pointer bg-blues text-white px-3 py-1 text-sm font-bold rounded-2xl transition-colors duration-200 hover:bg-blue-600 outline-none ml-auto whitespace-nowrap"
                    >
                      Preview
                    </router-link>

                    <!-- <router-link
                    :to="{
                      name: 'AdminCoursePreview',
                      params: { course_id: course.id },
                    }"
                    class="cursor-pointer bg-blues text-white px-3 py-1 text-sm font-bold rounded-2xl transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
                  >
                    C
                  </router-link> -->
                  </div>

                  <!-- DuplicateCourse -->
                  <!-- <div
                    class="mt-3"
                    v-if="
                      this.userInfo.user.permission == 'super_admin' ||
                      this.userInfo.user.permission == 'hod' ||
                      this.userInfo.user.permission == 'co-ordinator'
                    "
                  >
                    <button
                      @click="DuplicateCourse(course.id)"
                      class="cursor-pointer bg-blues text-white px-3 py-1 text-sm font-bold rounded-2xl transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
                    >
                      Duplicate
                    </button>
                  </div> -->

                  <!-- </div> -->
                </div>
              </div>
            </div>

            <Pagination
              :totalPages="totalPages"
              ref="paginationRef"
              @page-changed="this.getCourses"
            />
          </div>

          <div v-else class="text-lg font-normal text-center">
            No data Found
          </div>

          <!-- {{ pageArray }} -->
        </div>
      </div>
    </div>

    <div
      v-if="addLessonUnitPopup"
      class="fixed z-50 w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0"
    >
      <AddLessonUnit
        :course_id="currentId"
        @close-AddUnit="closeReciveEmitAddUnit"
      />
    </div>

    <div
      v-if="changeInstructorPopup != null"
      class="fixed z-50 w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0 flex justify-center items-center"
    >
      <div
        class="container px-6 mx-auto max-w-[1200px] flex flex-col gap-10 my-10 pb-10"
      >
        <div class="pb-10">
          <form
            ref="changeInsRef"
            @submit.prevent="completeUnitStart"
            class="rounded-3xl py-10 px-10 pb-2 heightfix bg-white overflow-y-auto flex flex-col gap-5"
            style="box-shadow: 0px 2px 20px 0px #105c8e26"
          >
            <div class="flex items-center justify-end gap-4">
              <button
                @click="changeInstructorPopup = null"
                class="bg-blues text-xs font-bold text-white px-5 py-1.5 rounded-full cursor-pointer"
              >
                Close
              </button>
            </div>

            <div class="flex flex-col gap-3 hidden">
              <label class="text-sm">Select Faculty </label>
              <select
                id="instructor"
                class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3"
              >
                <option value="" disabled>Select Faculty</option>
                <option
                  v-for="instructor in instructor_lists"
                  :key="instructor.id"
                  :value="instructor.id"
                >
                  {{ instructor.user.email }}
                </option>
              </select>
            </div>

            <div class="flex flex-col gap-3">
              <label class="text-sm font-medium">Select Faculty</label>
              <ul
                class="w-full border rounded-lg shadow-md h-[150px] overflow-y-auto mt-1 p-2 space-y-2"
                :class="
                  instructor_lists.length === 0 ? 'bg-gray-200' : 'bg-white'
                "
              >
                <li
                  v-for="instructor in instructor_lists"
                  :key="instructor.id"
                  class="flex items-center gap-2 cursor-pointer"
                >
                  <input
                    type="checkbox"
                    :value="instructor.id"
                    v-model="selectedInstructors"
                    class="form-checkbox accent-blue-600"
                  />
                  <span>{{ instructor.user.email }}</span>
                </li>
              </ul>
            </div>

            <div class="pb-8 flex items-center gap-3">
              <button
                type="submit"
                :disabled="disable_submit == true"
                :class="
                  this.disable_submit == true
                    ? 'bg-gray-200 text-black cursor-not-allowed'
                    : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                "
                class="rounded-lg text-sm px-4 py-2"
              >
                Submit
              </button>
              <img
                v-if="disable_submit"
                src="@/assets/loading.gif"
                alt="loading"
                class="w-6 h-6 object-contain"
              />
            </div>
          </form>
        </div>
      </div>
      <!-- <AddLessonUnit
        :course_id="currentId"
        @close-AddUnit="closeReciveEmitAddUnit"
      /> -->
    </div>
  </div>
</template>

<script>
import Header from "@/components/Admin/Header.vue";
import HodHeader from "@/components/Hod/Header.vue";
import CoordinateHeader from "@/components/Coordinate/Header.vue";
import InstructorHeader from "@/components/Instructor/Header.vue";
import ConfirmPopup from "@/components/ConfirmPopup.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import AddLessonUnit from "@/components/Common/AddLessonUnit.vue";
import Pagination from "@/components/Pagination.vue";
import DuplicatePopup from "@/components/DuplicatePopup.vue";

export default {
  components: {
    Header,
    FlashMessage,
    ConfirmPopup,
    AddLessonUnit,
    HodHeader,
    CoordinateHeader,
    InstructorHeader,
    Pagination,
    DuplicatePopup,
  },

  data() {
    return {
      // Popup states
      changeInstructorPopup: null,
      popupwindow: false,
      duplicatewindow: false,
      addLessonUnitPopup: false,

      // Data
      courselist: [],
      instructorInfo: "",
      messages: "",
      loading: true,
      search_list: "",
      searchTimeout: null,
      currentId: null,
      totalPages: 1,
      current_page: 1,
      pageSize: 5,
      pageArray: [],
      course_count: null,
      disable_submit: false,
      selectedInstructors: [],
      titlepass: "",
      idpass: null,

      // Filter data
      batch_years: [],
      programs: [],
      semetser_list: [],
      course_types: [],
      instructor_list: [],
      instructor_lists: [],

      // Selected filter values
      selectedBatchId: "",
      selectedProgramId: "",
      selectedSemesterId: "",
      selectedCourseType: "",
      selectedInstructorEmail: "",
      selectedInstructorName: "",
      selectedPublishStatus: "",
      selected_filter: "",
      deleteLoading: false,
    };
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },

  async created() {
    await this.getbatch();
    await this.getInstructorList();
    await this.getCourses(1);
  },

  methods: {
    // Batch Methods
    async getbatch() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API}/batch-list/?Key=${this.userInfo.token_key}`,
        );
        this.batch_years = res.data.data || [];
      } catch (err) {
        console.error("Error fetching batches:", err);
        this.batch_years = [];
      }
    },

    async onBatchChange() {
      // Reset dependent filters
      this.selectedProgramId = "";
      this.selectedSemesterId = "";
      this.selectedCourseType = "";
      this.selectedInstructorEmail = "";
      this.selectedInstructorName = "";
      this.selectedPublishStatus = "";

      // Clear dependent dropdowns
      this.programs = [];
      this.semetser_list = [];
      this.course_types = [];
      this.instructor_list = [];

      if (this.selectedBatchId) {
        await this.getProgramsByBatch(this.selectedBatchId);
      }

      this.getCourses(1);
    },

    async getProgramsByBatch(batchId) {
      if (!batchId) {
        this.programs = [];
        return;
      }

      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API}/program-list/?batch__id=${batchId}&Key=${this.userInfo.token_key}`,
        );
        this.programs = res.data.data || [];
      } catch (err) {
        console.error("Error fetching programs:", err);
        this.programs = [];
      }
    },

    // Program Methods
    async onProgramChange() {
      // Reset dependent filters
      this.selectedSemesterId = "";
      this.selectedCourseType = "";
      this.selectedInstructorEmail = "";
      this.selectedInstructorName = "";

      // Clear dependent dropdowns
      this.semetser_list = [];
      this.course_types = [];
      this.instructor_list = [];

      if (this.selectedProgramId && this.selectedBatchId) {
        await this.getSemestersByProgramAndBatch();
      }

      this.getCourses(1);
    },

    async getSemestersByProgramAndBatch() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API}/semetser-get/?Key=${this.userInfo.token_key}&department__program__id=${this.selectedProgramId}&batch__id=${this.selectedBatchId}`,
        );
        this.semetser_list = res.data.data || [];
      } catch (err) {
        console.error("Error fetching semesters:", err);
        this.semetser_list = [];
      }
    },

    // Semester Methods
    async onSemesterChange() {
      // Reset dependent filters
      this.selectedCourseType = "";
      this.selectedInstructorEmail = "";
      this.selectedInstructorName = "";

      // Clear dependent dropdowns
      this.course_types = [];
      this.instructor_list = [];

      if (this.selectedProgramId && this.selectedSemesterId) {
        await this.getCourseTypes();
      }

      this.getCourses(1);
    },

    async getCourseTypes() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API}/course_type/?Key=${this.userInfo.token_key}&program_id=${this.selectedProgramId}&semester_id=${this.selectedSemesterId}`,
        );
        this.course_types = res.data.data || [];
      } catch (err) {
        console.error("Error fetching course types:", err);
        this.course_types = [];
      }
    },

    // Course Type Methods
    async onCourseTypeChange() {
      // Reset dependent filters
      this.selectedInstructorEmail = "";
      this.selectedInstructorName = "";

      // Clear dependent dropdowns
      this.instructor_list = [];

      if (
        this.selectedCourseType &&
        this.selectedProgramId &&
        this.selectedSemesterId
      ) {
        await this.getInstructorsByFilters();
      }

      this.getCourses(1);
    },

    async getInstructorsByFilters() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API}/instructor-filterset-get/?Key=${this.userInfo.token_key}&course_type=${this.selectedCourseType}&program_id=${this.selectedProgramId}&semester_id=${this.selectedSemesterId}`,
        );
        this.instructor_list = (res.data.data || []).filter(
          (item) => item.display_name != null,
        );
      } catch (err) {
        console.error("Error fetching instructors:", err);
        this.instructor_list = [];
      }
    },

    // Instructor Methods
    async getInstructorList() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API}/instructor_all/?Key=${this.userInfo.token_key}`,
        );
        this.instructor_lists = res.data.products || [];
      } catch (err) {
        console.error("Error fetching instructors:", err);
        this.instructor_lists = [];
      }
    },

    findinstructor(course_id) {
      const course = this.courselist.find((c) => c.id === course_id);
      if (course && course.instructor) {
        this.selectedInstructors = course.instructor.map(
          (instructor) => instructor.id,
        );
      } else {
        this.selectedInstructors = [];
      }
    },

    async completeUnitStart() {
      this.disable_submit = true;
      const instructorIds = this.selectedInstructors.map(Number);

      try {
        const response = await axios.put(
          `${process.env.VUE_APP_API}/categoryinstructorupdate/${this.changeInstructorPopup}/?Key=${this.userInfo.token_key}`,
          {
            id: this.changeInstructorPopup,
            instructor: instructorIds,
          },
        );

        if (response.data.status == "200") {
          this.messages = {
            text: "Instructor Changed Successfully.",
            type: "success",
          };
          setTimeout(() => {
            if (this.$refs.changeInsRef) this.$refs.changeInsRef.reset();
            this.getCourses(1);
            this.changeInstructorPopup = null;
            this.messages = { text: "", type: "" };
          }, 2000);
        } else {
          this.messages = {
            text: "Error Issue.",
            type: "error",
          };
          setTimeout(() => {
            this.messages = { text: "", type: "" };
          }, 2000);
        }
      } catch (err) {
        console.error(err);
        this.messages = {
          text: "Something went wrong.",
          type: "error",
        };
      } finally {
        this.disable_submit = false;
      }
    },

    handleDuplicateClose() {
      this.duplicatewindow = false;
      this.getCourses(1);
    },

    handleSearchDebounced() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.getCourses(1);
      }, 500);
    },

    async getCourses(page) {
      this.current_page = page;

      const params = new URLSearchParams();
      params.append("page", page);
      params.append("Key", this.userInfo.token_key);

      if (this.selectedBatchId) params.append("batch_id", this.selectedBatchId);
      if (this.selectedProgramId)
        params.append("program_id", this.selectedProgramId);
      if (this.selectedSemesterId)
        params.append("semester_id", this.selectedSemesterId);
      if (this.selectedCourseType)
        params.append("course_type", this.selectedCourseType);
      if (this.selectedInstructorEmail)
        params.append("instructor_email", this.selectedInstructorEmail);
      if (this.selectedInstructorName)
        params.append("instructor_name", this.selectedInstructorName);
      if (this.selectedPublishStatus !== "")
        params.append("is_published", this.selectedPublishStatus);
      if (this.search_list) params.append("search", this.search_list);
      if (this.selected_filter) params.append("ordering", this.selected_filter);

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/courses/?${params.toString()}`,
        );

        if (response.data.status == 200) {
          this.totalPages = response.data.data.total_page;
          this.current_page = response.data.data.current_page;
          this.courselist = response.data.data.data.data || [];
          this.course_count = response.data.data.total || 0;
        } else {
          this.course_count = 0;
          this.courselist = [];
        }
      } catch (err) {
        console.error("Error fetching courses:", err);
        this.course_count = 0;
        this.courselist = [];
      } finally {
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },

    async deletecourse(data) {
      this.deleteLoading = true;

      try {
        const response = await axios.delete(
          `${process.env.VUE_APP_API}/courseupdate/${data}/?Key=${this.userInfo.token_key}`,
        );

        if (response.status == 204) {
          this.messages = {
            text: "Deleted successfully",
            type: "success",
          };

          this.popupwindow = false;

          setTimeout(() => {
            this.getCourses(1);
            this.messages = {
              text: "",
              type: "",
            };
          }, 2000);
        } else {
          this.messages = {
            text: "Delete Failed",
            type: "error",
          };

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "",
        };
      }, 2000);
        }
      } catch (err) {
        console.error(err);

        this.messages = {
          text: "Delete Failed",
          type: "error",
        };

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "",
        };
      }, 2000);
      } finally {
        this.deleteLoading = false;
      }
    },

    async filterorder() {
      if (!this.selected_filter) return;

      this.loading = true;
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/courses/?ordering=${this.selected_filter}&Key=${this.userInfo.token_key}`,
        );

        if (response.data.status == 200) {
          this.totalPages = response.data.data.total_page;
          this.current_page = response.data.data.current_page;
          this.courselist = response.data.data.data.data || [];
          this.course_count = response.data.data.total || 0;
        } else {
          this.courselist = [];
          this.course_count = 0;
        }
      } catch (err) {
        console.error("Error sorting courses:", err);
        this.courselist = [];
      } finally {
        this.loading = false;
      }
    },

    clearFilters() {
      // Reset all selected values
      this.selectedBatchId = "";
      this.selectedProgramId = "";
      this.selectedSemesterId = "";
      this.selectedCourseType = "";
      this.selectedInstructorEmail = "";
      this.selectedInstructorName = "";
      this.selectedPublishStatus = "";
      this.selected_filter = "";
      this.search_list = "";

      // Clear dropdown data
      this.programs = [];
      this.semetser_list = [];
      this.course_types = [];
      this.instructor_list = [];

      // Reload courses
      this.getCourses(1);
    },
  },
};
</script>

<style scoped>
/* Add any custom styles here if needed */
</style>
